const translations = {
  en: {
    title: 'Serhan Kombos Otomotiv',
    description: 'Register for Serhan Kombos Otomotiv and receive your invitation.',
    bingoTitle: 'Kombos Otomotiv Bingo',
    bingoDescription: 'Register for your chance to win 500,000 TL. Complete your registration, submit your car document, and join us for an exciting event.',
    name: 'Name',
    surname: 'Surname',
    email: 'Email',
    phone: 'Phone Number',
    dob: 'Date of Birth',
    vehicleBrand: 'Vehicle Brand',
    vehicleModel: 'Vehicle Model',
    modelYear: 'Model Year',
    licensePlate: 'License plate',
    uploadStub: 'Upload your vehicle stub',
    browseFiles: 'Browse Files',
    dragDrop: 'Drag and drop files here',
    noFileChosen: 'No file chosen',
    stubInfo: 'Allowed: JPG, JPEG, PNG, WebP. Maximum file size: 1 MB. Recommended: ~250 KB. Maximum 1 photo per submission. Your Mercedes ownership must be verified for your invitation to be generated. If your document is not with you at the moment, you can complete your registration and upload it later.',
    location: 'Your Location',
    pleaseSelect: 'Please Select',
    continueLater: 'Continue later',
    completeRegistration: 'Complete Registration',
    placeholderName: 'Name',
    placeholderSurname: 'Surname',
    placeholderEmail: 'example@example.com',
    placeholderPhone: '+90 (500) 000-0000',
    placeholderDob: 'DD-MM-YYYY',
    placeholderVehicleBrand: 'e.g., Mercedes-Benz',
    placeholderVehicleModel: 'e.g., C-Class',
    placeholderModelYear: 'e.g., 2023',
    placeholderLicensePlate: 'e.g., AB 1234',
    locations: {
      lefkosa: 'Lefkosa',
      kyrenia: 'Kyrenia',
      haspolat: 'Haspolat',
      famagusta: 'Famagusta',
      guzelyurt: 'Guzelyurt'
    },
    successMessage: 'Registration submitted successfully! You will receive your invitation soon.',
    draftMessage: 'Your progress has been saved. You can continue later.',
    draftEmailRequired: 'Please enter your email so your progress can be saved.',
    duplicateEmailMessage: 'This email is already registered. Please use a different email address.',
    allFieldsRequiredMessage: 'Please fill in all required fields.',
    adminTitle: 'Admin Dashboard',
    adminSubtitle: 'View all registrations',
    noRecords: 'No registrations yet.',
    downloadExcel: 'Download Excel',
    clearAll: 'Clear All',
    confirmClear: 'Are you sure you want to clear all records?',
    totalRegistrations: 'Total Registrations',
    submittedAt: 'Submitted At',
    receiptFile: 'Car Document File',
    receiptStatus: 'Car Document Status',
    verificationStatus: 'Verification Status',
    invitationStatus: 'Invitation Status',
    reminderHistory: 'Reminder History',
    actions: 'Actions',
    chassisNumber: 'Chassis Number',
    rejectionReason: 'Rejection Reason',
    adminNote: 'Admin Note',
    sendMessage: 'Send Message',
    sendReminder: 'Send Reminder',
    approveRegistration: 'Approve',
    rejectRegistration: 'Reject',
    confirmApproval: 'Are all details correct and well verified?',
    confirmApprovalYes: 'Yes, approve',
    confirmApprovalNo: 'No, go back',
    selectRejectionReason: 'Reason:',
    confirmRejection: 'Confirm Rejection',
    cancel: 'Cancel',
    otherReason: 'Other:',
    otherReasonPlaceholder: 'Please specify other reason...',
    pleaseEnterMessage: 'Please enter a message',
    messageSentAndArchived: 'Message sent and registration archived',
    messageSentSuccessfully: 'Message sent successfully!',
    pleaseSelectTemplateOrEnterMessage: 'Please select a template or enter a custom message',
    informationRequestedAndArchived: 'Information requested and registration archived',
    informationRequestSentSuccessfully: 'Information request sent successfully!',
    reminderSubject: 'Reminder: Please complete your registration',
    reminderSentSuccessfully: 'Reminder sent successfully!',
    registrationApprovedAndArchived: 'Registration approved and archived',
    pleaseEnterRejectionReason: 'Please enter a rejection reason in the textarea before rejecting.',
    pleaseSelectRejectionReason: 'Please select at least one rejection reason.',
    registrationRejectedAndArchived: 'Registration rejected and archived',
    viewReceipt: 'View Car Document',
    viewReceiptButton: 'View',
    rejectionReasonPlaceholderShort: 'Rejection reason...',
    messageSent: 'Message sent successfully',
    selectStatus: 'Select status',
    receiptRejected: 'Car document rejected - invalid image',
    detailsRejected: 'Details rejected - incorrect information',
    rejectionReasonPlaceholder: 'Enter rejection reason...',
    rejectionReasonPlaceholderTr: 'Reddedilme nedenini girin...',
    reject: 'Reject',
    alreadyRejected: 'Already Rejected',
    archive: 'Archive',
    viewArchive: 'View Archive',
    activeRegistrations: 'Active Registrations',
    archivedRegistrations: 'Archived Registrations',
    delete: 'Delete',
    deleteRecord: 'Delete Record',
    deleteConfirm: 'Are you sure you want to delete this record?',
    errorDeletingArchived: 'Error deleting archived registration',
    archivedAt: 'Archived At',
    archiveReason: 'Archive Reason',
    backToForm: 'Back to Form',
    language: 'Language',
    languageOptions: { tr: 'Turkish', en: 'English' },
    adminLogin: 'Login',
    password: 'Password',
    login: 'Login',
    logout: 'Logout',
    navHome: 'Home',
    navAdmin: 'Admin',
    navRegister: 'Register',
    navAbout: 'About',
    navFaq: 'FAQ',
    navBingo: 'Bingo',
    aboutTitle: 'About Us',
    aboutDescription: 'Learn more about Serhan Kombos Otomotiv.',
    aboutIntro: 'We are a well-established automotive company based in Northern Cyprus. We specialize in the sale of new and used vehicles, vehicle servicing, spare parts, and after-sales services. We represent well-known automotive brands and have built a strong reputation for quality, customer service, and reliability in the Cyprus automotive market.',
    ourServices: 'Our Services',
    ourServicesDescription: 'Our services are designed to provide customers with a complete automotive experience, from choosing and purchasing a vehicle to ongoing maintenance and after-sales support.',
    serviceNewVehicle: 'New vehicle sales',
    serviceUsedVehicle: 'Used vehicle sales',
    serviceServicing: 'Vehicle servicing and maintenance',
    serviceRepairs: 'Repairs and after-sales support',
    serviceParts: 'Genuine spare parts',
    serviceInspection: 'Vehicle inspection and support',
    serviceTradeIn: 'Vehicle trade-in and purchasing services',
    ourExperience: 'Our Experience',
    ourExperienceDescription: 'With decades of experience in the automotive sector, Serhan Kombos Otomotiv combines industry knowledge with professional customer service. Our experienced team works to ensure that every customer receives reliable advice, quality products, and efficient service.',
    ourCommitment: 'Our Commitment',
    ourCommitmentDescription: 'Our goal is to provide a trusted and professional automotive experience for every customer. We are committed to maintaining high standards of service, offering quality vehicles and products, and continuously improving the way we serve our customers.',
    ourVision: 'Our Vision',
    ourVisionDescription: 'To remain a trusted name in the Northern Cyprus automotive market by providing high-quality vehicles, professional services, and customer-focused solutions while continuing to grow and develop with the changing needs of the automotive industry.',
    ourMission: 'Our Mission',
    ourMissionDescription: 'To deliver reliable automotive products and services through professionalism, quality, transparency, and customer satisfaction, while building long-term relationships with our customers and business partners.',
    whyChooseUs: 'Why Choose Us?',
    whyExperience: 'Experience',
    whyExperienceDesc: 'Decades of experience in the automotive industry.',
    whyQuality: 'Quality',
    whyQualityDesc: 'Commitment to high standards across our vehicles and services.',
    whyProfessional: 'Professional Service',
    whyProfessionalDesc: 'An experienced team dedicated to customer needs.',
    whyBrands: 'Trusted Brands',
    whyBrandsDesc: 'Working with internationally recognized automotive brands.',
    whyComplete: 'Complete Automotive Solutions',
    whyCompleteDesc: 'Sales, servicing, spare parts, and after-sales support in one place.',
    whySatisfaction: 'Customer Satisfaction',
    whySatisfactionDesc: 'Building long-term relationships through reliable and professional service.'
  },
  tr: {
    title: 'Serhan Kombos Otomotiv',
    description: 'Serhan Kombos Otomotiv\'e kayıt olun ve davetiyenizi alın.',
    bingoTitle: 'Kombos Otomotiv Tombala',
    bingoDescription: '500.000 TL kazanma şansı sizleri bekliyor. Kaydınızı tamamlayın, koçanınızı gönderin ve heyecan verici bir etkinliğe katılın.',
    ticketTitle: 'Kombos Tombala Gecesi Mercedes Sahiplerine Özel',
    ticketTitleEn: 'Kombos Bingo Night Exclusive for Mercedes Owners',
    name: 'Ad',
    surname: 'Soyadı',
    email: 'E-posta',
    phone: 'Telefon Numarası',
    dob: 'Doğum Tarihi',
    vehicleBrand: 'Araç Markası',
    vehicleModel: 'Araç Modeli',
    modelYear: 'Model Yılı',
    licensePlate: 'Plaka',
    uploadStub: 'Araç ruhsatını yükleyin',
    browseFiles: 'Dosyalara Göz At',
    dragDrop: 'Dosyaları buraya sürükleyip bırakın',
    noFileChosen: 'Dosya seçilmedi',
    stubInfo: 'İzin verilen formatlar: JPG, JPEG, PNG, WebP. Maksimum dosya boyutu: 1 MB. Önerilen: ~250 KB. Gönderim başına maksimum 1 fotoğraf. Davetiyenizin oluşturulması için Mercedes sahipliğiniz doğrulanmalıdır. Koçanınız şu anda yanınızda değilse, kaydınızı tamamlayıp daha sonra belgenizi yükleyebilirsiniz.',
    location: 'Konumunuz',
    pleaseSelect: 'Lütfen Seçiniz',
    continueLater: 'Sonra Devam Et',
    completeRegistration: 'Kaydı Tamamla',
    placeholderName: 'Ad',
    placeholderSurname: 'Soyadı',
    placeholderEmail: 'ornek@ornek.com',
    placeholderPhone: '+90 (500) 000-0000',
    placeholderDob: 'GG-AA-YYYY',
    placeholderVehicleBrand: 'örn., Mercedes-Benz',
    placeholderVehicleModel: 'örn., C-Class',
    placeholderModelYear: 'örn., 2023',
    placeholderLicensePlate: 'örn., AB 1234',
    locations: {
      lefkosa: 'Lefkoşa',
      kyrenia: 'Girne',
      haspolat: 'Haspolat',
      famagusta: 'Gazimağusa',
      guzelyurt: 'Güzelyurt'
    },
    successMessage: 'Kaydınız başarıyla gönderildi! Yakında davetiyenizi alacaksınız.',
    draftMessage: 'İlerleme durumunuz kaydedildi. Daha sonra devam edebilirsiniz.',
    draftEmailRequired: 'Lütfen ilerlemenizin kaydedilmesi için e-posta adresinizi girin.',
    duplicateEmailMessage: 'Bu e-posta adresi zaten kayıtlı. Lütfen farklı bir e-posta adresi kullanın.',
    allFieldsRequiredMessage: 'Lütfen tüm zorunlu alanları doldurun.',
    adminTitle: 'Yönetim Paneli',
    adminSubtitle: 'Tüm kayıtları görüntüle',
    noRecords: 'Henüz kayıt yok.',
    downloadExcel: 'Excel İndir',
    clearAll: 'Tümünü Temizle',
    confirmClear: 'Tüm kayıtları silmek istediğinize emin misiniz?',
    totalRegistrations: 'Toplam Kayıt',
    submittedAt: 'Gönderim Zamanı',
    receiptFile: 'Koçan Dosyası',
    receiptStatus: 'Koçan Durumu',
    verificationStatus: 'Doğrulama Durumu',
    invitationStatus: 'Davetiye Durumu',
    reminderHistory: 'Hatırlatma Geçmişi',
    actions: 'İşlemler',
    chassisNumber: 'Şasi Numarası',
    rejectionReason: 'Reddedilme Nedeni',
    adminNote: 'Yönetici Notu',
    sendMessage: 'Mesaj Gönder',
    sendReminder: 'Hatırlatma Gönder',
    approveRegistration: 'Onayla',
    rejectRegistration: 'Reddet',
    confirmApproval: 'Tüm detaylar doğru ve iyi doğrulandı mı?',
    confirmApprovalYes: 'Evet, onayla',
    confirmApprovalNo: 'Hayır, geri dön',
    selectRejectionReason: 'Neden:',
    confirmRejection: 'Reddetmeyi Onayla',
    cancel: 'İptal',
    otherReason: 'Diğer:',
    otherReasonPlaceholder: 'Lütfen diğer nedeni belirtin...',
    pleaseEnterMessage: 'Lütfen bir mesaj girin',
    messageSentAndArchived: 'Mesaj gönderildi ve kayıt arşivlendi',
    messageSentSuccessfully: 'Mesaj başarıyla gönderildi!',
    pleaseSelectTemplateOrEnterMessage: 'Lütfen bir şablon seçin veya özel mesaj girin',
    informationRequestedAndArchived: 'Bilgi istendi ve kayıt arşivlendi',
    informationRequestSentSuccessfully: 'Bilgi isteği başarıyla gönderildi!',
    reminderSubject: 'Hatırlatma: Lütfen kaydınızı tamamlayın',
    reminderSentSuccessfully: 'Hatırlatma başarıyla gönderildi!',
    registrationApprovedAndArchived: 'Kayıt onaylandı ve arşivlendi',
    pleaseEnterRejectionReason: 'Lütfen reddetmeden önce reddedilme nedenini metin alanına girin.',
    pleaseSelectRejectionReason: 'Lütfen en az bir reddedilme nedeni seçin.',
    registrationRejectedAndArchived: 'Kayıt reddedildi ve arşivlendi',
    viewReceipt: 'Koçanı Görüntüle',
    viewReceiptButton: 'Görüntüle',
    rejectionReasonPlaceholderShort: 'Reddetme nedeni...',
    messageSent: 'Mesaj başarıyla gönderildi',
    selectStatus: 'Durum seçin',
    receiptRejected: 'Koçan reddedildi - geçersiz görsel',
    detailsRejected: 'Detaylar reddedildi - yanlış bilgi',
    rejectionReasonPlaceholder: 'Reddedilme nedenini girin...',
    reject: 'Reddet',
    alreadyRejected: 'Zaten Reddedildi',
    archive: 'Arşivle',
    viewArchive: 'Arşivi Görüntüle',
    activeRegistrations: 'Aktif Kayıtlar',
    archivedRegistrations: 'Arşivlenmiş Kayıtlar',
    archivedAt: 'Arşiv Tarihi',
    archiveReason: 'Arşivleme Nedeni',
    delete: 'Sil',
    deleteRecord: 'Kaydı Sil',
    deleteConfirm: 'Bu kaydı silmek istediğinize emin misiniz?',
    errorDeletingArchived: 'Arşiv kaydı silinirken hata oluştu',
    backToForm: 'Forma Dön',
    language: 'Dil',
    languageOptions: { tr: 'Türkçe', en: 'English' },
    adminLogin: 'Giriş',
    password: 'Şifre',
    login: 'Giriş Yap',
    logout: 'Çıkış',
    navHome: 'Ana Sayfa',
    navAdmin: 'Yönetici',
    navRegister: 'Kayıt',
    navAbout: 'Hakkımızda',
    navFaq: 'SSS',
    navBingo: 'Tombala',
    aboutTitle: 'Hakkımızda',
    aboutDescription: 'Serhan Kombos Otomotiv hakkında daha fazla bilgi edinin.',
    aboutIntro: 'Kuzey Kıbrıs\'ta faaliyet gösteren köklü bir otomotiv şirketiyiz. Yeni ve ikinci el araç satışı, araç servis hizmetleri, yedek parça ve satış sonrası hizmetleri alanında uzmanlaşmışız. Bilinen otomotiv markalarını temsil ediyor ve Kıbrıs otomotiv piyasasında kalite, müşteri hizmeti ve güvenilirlik konusunda güçlü bir itibar yaratmışıyoruz.',
    ourServices: 'Hizmetlerimiz',
    ourServicesDescription: 'Hizmetlerimiz, müşterilere araç seçimi ve satın alımından başlayarak, sürekli bakım ve satış sonrası desteğe kadar eksiksiz bir otomotiv deneyimi sunmak için tasarlanmıştır.',
    serviceNewVehicle: 'Yeni araç satışı',
    serviceUsedVehicle: 'İkinci el araç satışı',
    serviceServicing: 'Araç servis ve bakımı',
    serviceRepairs: 'Onarım ve satış sonrası destek',
    serviceParts: 'Orijinal yedek parça',
    serviceInspection: 'Araç muayene ve destek hizmetleri',
    serviceTradeIn: 'Araç takas ve alım hizmetleri',
    ourExperience: 'Deneyimimiz',
    ourExperienceDescription: 'Otomotiv sektöründeki on yıllık deneyimle Serhan Kombos Otomotiv, sektör bilgisini profesyonel müşteri hizmetiyle birleştirir. Deneyimli ekibimiz, her müşterinin güvenilir tavsiye, kaliteli ürün ve verimli hizmet almasını sağlamak için çalışır.',
    ourCommitment: 'Sözümüz',
    ourCommitmentDescription: 'Amacımız, her müşteriye güvenilir ve profesyonel bir otomotiv deneyimi sunmaktır. Hizmet standartlarını yüksek tutmak, kaliteli araçlar ve ürünler sunmak ve müşterilerimize sunduğumuz hizmeti sürekli iyileştirmek için taahhütlüyüz.',
    ourVision: 'Vizyonumuz',
    ourVisionDescription: 'Yüksek kaliteli araçlar, profesyonel hizmetler ve müşteri odaklı çözümler sunarak Kuzey Kıbrıs otomotiv piyasasında güvenilir bir marka olmaya devam etmek, otomotiv endüstrisinin değişen ihtiyaçlarıyla büyümek ve gelişmek.',
    ourMission: 'Misyonumuz',
    ourMissionDescription: 'Profesyonellik, kalite, şeffaflık ve müşteri memnuniyeti yoluyla güvenilir otomotiv ürünleri ve hizmetleri sunmak, müşterilerimiz ve iş ortaklarımızla uzun vadeli ilişkiler kurmak.',
    whyChooseUs: 'Neden Bizi Tercih Edin?',
    whyExperience: 'Deneyim',
    whyExperienceDesc: 'Otomotiv endüstrisinde on yıllık deneyim.',
    whyQuality: 'Kalite',
    whyQualityDesc: 'Araçlarımız ve hizmetlerimizde yüksek standartlara bağlılık.',
    whyProfessional: 'Profesyonel Hizmet',
    whyProfessionalDesc: 'Müşteri ihtiyaçlarına adanmış deneyimli bir ekip.',
    whyBrands: 'Güvenilir Markalar',
    whyBrandsDesc: 'Uluslararası olarak tanınan otomotiv markaları ile çalışmak.',
    whyComplete: 'Kapsamlı Otomotiv Çözümleri',
    whyCompleteDesc: 'Tek bir yerde satış, servis, yedek parça ve satış sonrası destek.',
    whySatisfaction: 'Müşteri Memnuniyeti',
    whySatisfactionDesc: 'Güvenilir ve profesyonel hizmetle uzun vadeli ilişkiler kurmak.'
  }
};

export default translations;
